import { Constants } from '@ui/shared/model';
import {
  ConstantsActions,
  FETCH_CONSTANTS,
  FETCH_CONSTANTS_FAIL,
  FETCH_CONSTANTS_SUCCESS
} from './constants.actions';

export interface ConstantsState {
  constants: Constants;
  loading: boolean;
  loaded: boolean;
  error: Error;
}

export const initialState: ConstantsState = {
  constants: null,
  loading: false,
  loaded: false,
  error: null
};

export function reducer(
  state = initialState,
  action: ConstantsActions
): ConstantsState {
  switch (action.type) {
    case FETCH_CONSTANTS: {
      return {
        ...state,
        loading: true
      };
    }

    case FETCH_CONSTANTS_FAIL: {
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.error
      };
    }

    case FETCH_CONSTANTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        constants: action.data
      };
    }

    default:
      return state;
  }
}

export const getConstants = (state: ConstantsState) => state.constants;
export const getLoading = (state: ConstantsState) => state.loading;
export const getLoaded = (state: ConstantsState) => state.loaded;

export const getError = (state: ConstantsState) => state.error;
